import { AbstractControl } from '@angular/forms';

import { ValidationErrors, ValidatorFn } from '@angular/forms';
export class CustomValidators {   

    static cpf(control: AbstractControl): Record<string, boolean> | null {
        if (!control.value) {
            return { invalid: true };
        }

        const cpf = control.value.replace(/[^\d]+/g, '');

        switch (cpf) {
            case cpf.length !== 11:
            case '00000000000':
            case '11111111111':
            case '22222222222':
            case '33333333333':
            case '44444444444':
            case '55555555555':
            case '66666666666':
            case '77777777777':
            case '88888888888':
            case '99999999999': {
                return { invalid: true };
            }
        }

        let add = 0;
        for (let i = 0; i < 9; i++) {
            add += parseInt(cpf.charAt(i), 10) * (10 - i);
        }

        let rev = 11 - (add % 11);
        if (rev === 10 || rev === 11) {
            rev = 0;
        }
        if (rev !== parseInt(cpf.charAt(9), 10)) {
            return { invalid: true };
        }

        add = 0;
        for (let i = 0; i < 10; i++) {
            add += parseInt(cpf.charAt(i), 10) * (11 - i);
        }
        rev = 11 - (add % 11);
        if (rev === 10 || rev === 11) {
            rev = 0;
        }

        if (rev !== parseInt(cpf.charAt(10), 10)) {
            return { invalid: true };
        }

        return null;
    }

    static cnpj(control: AbstractControl): Record<string, boolean> | null {
        if (!control.value) {
            return { invalid: true };
        }

        const cnpj = control.value.replace(/[^\d]+/g, '');

        if (!cnpj) {
            return { invalid: true };
        }

        switch (cnpj) {
            case cnpj.length !== 14:
            case '00000000000000':
            case '11111111111111':
            case '22222222222222':
            case '33333333333333':
            case '44444444444444':
            case '55555555555555':
            case '66666666666666':
            case '77777777777777':
            case '88888888888888':
            case '99999999999999': {
                return { invalid: true };
            }
        }

        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        const digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) {
                pos = 9;
            }
        }

        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== parseInt(digitos.charAt(0), 10))  {
            return { invalid: true };
        }

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) {
                pos = 9;
            }
        }

        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== parseInt(digitos.charAt(1), 10)) {
            return { invalid: true };
        }

        return null;
    }

    static data(control: AbstractControl): Record<string, boolean> | null {
        if (control.value) {
            const er = /^((((0?[1-9]|[12]\d|3[01])[\.\-\/](0?[13578]|1[02])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[\.\-\/](0?[13456789]|1[012])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|(29[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;
            if (!er.test(control.value) || control.value === '') {
                return { invalid: true};
            } else {
                return null;
            }
        } else {
            return { invalid: true };
        }
    }

    static number(control: AbstractControl): Record<string, boolean> | null {
        if (control.value) {
            const value = control.value.replace(/[0-9]/g, '');
            if (value.length > 0) {
                return { invalid: true };
            } else {
                return null;
            }
        } else {
            return { invalid: true };
        }
    }

    static password(control: AbstractControl): Record<string, boolean> | null {        
        if (control.value 
            && control.value.length >= 6
            && control.value != '102030'
            && control.value != '123456'
            && /[A-Z]+/.test(control.value)
            && /[0-9]+/.test(control.value)) {
            return null;
        } else {
            return { invalid: true, password: true };
        }
    }

    static url(control: AbstractControl): Record<string, boolean> | null {
        const pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
        if (!pattern.test(control.value)) {
            return { invalid: true };
        } else {
            return null;
        }
    }

    static passwordMismatch(control: AbstractControl): Record<string, boolean> | null {
        const password = control.get('newPassword');
        const confirmPassword = control.get('confNewPassword');

        if ((password && confirmPassword) && password.value !== confirmPassword.value) {
            return { passwordMismatch: true };
        } else {
            return null;
        }
    }
}
// Validação personalizada
export function passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.get('newPassword') ? control.get('newPassword').value : '';
      const confirmPassword = control.get('confNewPassword') ? control.get('confNewPassword').value : '';
  
      const errors: ValidationErrors = {};
  
      if (password !== confirmPassword) {
        errors.passwordMismatch = 'A senha e a confirmação devem ser iguais.';
      }
  
      return Object.keys(errors).length > 0 ? errors : null;
    };
  }


  

